var device;
( function( $ ) {
	var animationEndEventNames = {
		'WebkitAnimation' : 'webkitAnimationEnd',
		'MozAnimation'    : 'animationend',
		'OAnimation'      : 'oAnimationEnd',
		'msAnimation'     : 'MSAnimationEnd',
		'animation'       : 'animationend'
	};
	var animationEnd = animationEndEventNames[ Modernizr.prefixed('animation') ];

	document.addEventListener( animationEnd, dispatchEvent, false );

	// check the animation name and operate accordingly
	function dispatchEvent( event ) {
		if ( event.animationName === 'desktop' ) {
			window.device = 'desktop';
		}
		else if ( event.animationName === 'tablet' ) {
			window.device = 'tablet';
		}
		else if ( event.animationName === 'mobileonly' ) {
			window.device = 'mobileonly';
		}
	}

	$( document ).ready( function() {
		switch ( $( 'body' ).css('border-top-color') ) {
			case 'rgb(255, 255, 255)':
				window.device = 'desktop';
				break;
			case 'rgb(254, 255, 255)':
				window.device = 'tablet';
				break;
			default:
				window.device = 'mobileonly';
		}
	} );

} )( jQuery );